// @flow
export const DETAILS_FILTER_SET = 'reports/DETAILS_FILTER_SET';

export const detailsFilterSet = (payload: boolean) => ({
  type: DETAILS_FILTER_SET,
  payload,
});
